const CeutaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111141)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path d="M19.9996 0C14.4767 0 9.47672 2.23859 5.85742 5.85781L19.9996 20V0Z" fill="black" />
      <path d="M0 20C0 25.5229 2.23859 30.5229 5.85781 34.1422L20 20H0Z" fill="black" />
      <path d="M20 40C25.5229 40 30.5229 37.7614 34.1422 34.1422L20 20V40Z" fill="black" />
      <path
        d="M40 19.9996C40 14.4767 37.7614 9.47672 34.1422 5.85742L20 19.9996H40Z"
        fill="black"
      />
      <path
        d="M13.0435 13.9136L19.9999 14.7834L26.9564 13.9136V9.73969L24.1738 11.131L19.9999 6.95703L15.826 11.131L13.0435 9.73969V13.9136Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9999 30.4346C16.1641 30.4346 13.0435 27.3139 13.0435 23.4782V16.522L15.6521 13.9131H24.3478L26.9564 16.522V23.4782C26.9564 27.3139 23.8358 30.4346 19.9999 30.4346Z"
        fill="#D80027"
      />
      <path
        d="M20.0002 27.8257C17.6027 27.8257 15.6523 25.8752 15.6523 23.4779V16.5215H24.348V23.4778C24.348 25.8752 22.3976 27.8257 20.0002 27.8257Z"
        fill="#F0F0F0"
      />
      <path d="M13.0435 13.9131H15.6521V16.5218H13.0435V13.9131Z" fill="#FFDA44" />
      <path d="M24.3477 13.9131H26.9563V16.5218H24.3477V13.9131Z" fill="#FFDA44" />
      <path d="M24.3477 19.5654H26.9563V22.1741H24.3477V19.5654Z" fill="#FFDA44" />
      <path d="M13.0435 19.5654H15.6521V22.1741H13.0435V19.5654Z" fill="#FFDA44" />
      <path
        d="M20.0002 27.8261C19.5458 27.8261 19.1078 27.7558 18.6958 27.626V30.3104C19.1186 30.3911 19.5542 30.4349 20.0002 30.4349C20.4461 30.4349 20.8817 30.3911 21.3046 30.3104V27.626C20.8926 27.7557 20.4546 27.8261 20.0002 27.8261Z"
        fill="#FFDA44"
      />
      <path
        d="M15.7103 24.1836L13.6284 26.2655C13.9894 27.0873 14.5044 27.8263 15.1373 28.4458L16.9811 26.602C16.3231 25.9663 15.8647 25.1257 15.7103 24.1836Z"
        fill="#FFDA44"
      />
      <path
        d="M26.3711 26.2664L24.2893 24.1846C24.1347 25.1266 23.6764 25.9671 23.0186 26.6031L24.8623 28.4468C25.4951 27.8272 26.0102 27.0882 26.3711 26.2664Z"
        fill="#FFDA44"
      />
      <path
        d="M19.1309 17.9707V19.4199C19.1309 19.9001 19.5202 20.2895 20.0004 20.2895C20.4806 20.2895 20.8699 19.9001 20.8699 19.4199V17.9707H19.1309Z"
        fill="#0052B4"
      />
      <path
        d="M19.1309 23.7676V25.2168C19.1309 25.697 19.5202 26.0863 20.0004 26.0863C20.4806 26.0863 20.8699 25.697 20.8699 25.2168V23.7676H19.1309Z"
        fill="#0052B4"
      />
      <path
        d="M21.7393 20.8701V22.3195C21.7393 22.7996 22.1286 23.189 22.6088 23.189C23.089 23.189 23.4783 22.7996 23.4783 22.3195V20.8701H21.7393Z"
        fill="#0052B4"
      />
      <path
        d="M19.1309 20.8701V22.3195C19.1309 22.7996 19.5202 23.189 20.0004 23.189C20.4806 23.189 20.8699 22.7996 20.8699 22.3195V20.8701H19.1309Z"
        fill="#0052B4"
      />
      <path
        d="M16.5215 20.8701V22.3195C16.5215 22.7996 16.9108 23.189 17.391 23.189C17.8713 23.189 18.2605 22.7996 18.2605 22.3195V20.8701H16.5215Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111141">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CeutaSvg;
